var _rect, _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentVehicleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 17,
    rx: 0.5,
    fill: "#03971B",
    fillOpacity: 0.1,
    stroke: "#03971B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4677 5.80078H21H20.5V17.5615H21.9783H28.2837H28.5C29.0523 17.5615 29.5 17.1138 29.5 16.5615V11.3052C29.5 11.1063 29.4407 10.9118 29.3295 10.7468L26.2973 6.24235C26.1114 5.96631 25.8005 5.80078 25.4677 5.80078Z",
    fill: "#03971B",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.366H21.5M20.2913 17.5615H20.5M20.5 17.5615H21.9783H28.2837H28.5C29.0523 17.5615 29.5 17.1138 29.5 16.5615V11.3052C29.5 11.1063 29.4407 10.9118 29.3295 10.7468L26.2973 6.24235C26.1114 5.96631 25.8005 5.80078 25.4677 5.80078H21H20.5V17.5615Z",
    stroke: "#03971B",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8.2V10.8C22.5 10.9105 22.5895 11 22.7 11H26.6263C26.786 11 26.8813 10.822 26.7927 10.6891L25.0594 8.08906C25.0223 8.03342 24.9598 8 24.893 8H22.7C22.5895 8 22.5 8.08954 22.5 8.2Z",
    fill: "white",
    stroke: "#03971B",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2.5,
    fill: "#E6F5E8",
    stroke: "#03971B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 18,
    r: 2.5,
    fill: "#E6F5E8",
    stroke: "#03971B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5004V6.49959C14.9998 6.32419 14.9535 6.15192 14.8658 6.00007C14.778 5.84821 14.6519 5.72211 14.5 5.63441L11 3.634C10.848 3.54622 10.6755 3.5 10.5 3.5C10.3245 3.5 10.152 3.54622 10 3.634L6.5 5.63441C6.34813 5.72211 6.22199 5.84821 6.13423 6.00007C6.04647 6.15192 6.00018 6.32419 6 6.49959V10.5004C6.00018 10.6758 6.04647 10.8481 6.13423 10.9999C6.22199 11.1518 6.34813 11.2779 6.5 11.3656L10 13.366C10.152 13.4538 10.3245 13.5 10.5 13.5C10.6755 13.5 10.848 13.4538 11 13.366L14.5 11.3656C14.6519 11.2779 14.778 11.1518 14.8658 10.9999C14.9535 10.8481 14.9998 10.6758 15 10.5004Z",
    fill: "#03971B",
    stroke: "#E6F5E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.5L10.5 8.5L15 6.5",
    fill: "#03971B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.5L10.5 8.5L15 6.5",
    stroke: "#E6F5E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.1971L10.5 8.34863",
    stroke: "#E6F5E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentVehicleIcon);
export default __webpack_public_path__ + "static/media/currentVehicleIcon.75d4241e164b2057b2927667104d7d15.svg";
export { ForwardRef as ReactComponent };